import { c as _c } from "react-compiler-runtime";
import React from "react";
import { ComboBoxStateContext, Group, Input as AriaInput, InputContext, useSlottedContext } from "react-aria-components";
import { useFieldErrorContext, useStyle } from "../context.js";
import { AlertCircle } from "../icons/line.js";
import { base, errorIcon, icon, input } from "./Input.css.js";
import { Spinner } from "./Spinner.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BaseInput = (t0, ref) => {
  const $ = _c(31);
  let LeftIcon;
  let props;
  let propsIsDisabled;
  let propsIsInvalid;
  let sizeVariant;
  let t1;
  let t2;
  let variant;
  if ($[0] !== t0) {
    ({
      sizeVariant,
      size: t1,
      isLoading: t2,
      isInvalid: propsIsInvalid,
      isDisabled: propsIsDisabled,
      variant,
      leftIcon: LeftIcon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = LeftIcon;
    $[2] = props;
    $[3] = propsIsDisabled;
    $[4] = propsIsInvalid;
    $[5] = sizeVariant;
    $[6] = t1;
    $[7] = t2;
    $[8] = variant;
  } else {
    LeftIcon = $[1];
    props = $[2];
    propsIsDisabled = $[3];
    propsIsInvalid = $[4];
    sizeVariant = $[5];
    t1 = $[6];
    t2 = $[7];
    variant = $[8];
  }
  const size = t1 === undefined ? "m" : t1;
  const isLoading = t2 === undefined ? false : t2;
  const inputProps = useSlottedContext(InputContext);
  const comboboxState = React.useContext(ComboBoxStateContext);
  const isDisabled = propsIsDisabled ?? inputProps?.disabled ?? false;
  const style = useStyle();
  const validation = useFieldErrorContext();
  const isInvalid = propsIsInvalid ?? validation?.isInvalid;
  const insideCombobox = comboboxState != null;
  const showErrorIcon = (comboboxState?.isOpen !== true && isInvalid) ?? false;
  const t3 = variant === "date";
  let t4;
  if ($[9] !== insideCombobox || $[10] !== isDisabled || $[11] !== isInvalid || $[12] !== showErrorIcon || $[13] !== size || $[14] !== sizeVariant || $[15] !== style || $[16] !== t3) {
    t4 = base({
      date: t3,
      error: isInvalid,
      insideCombobox,
      showErrorIcon,
      disabled: isDisabled,
      sizeVariant,
      size,
      style
    });
    $[9] = insideCombobox;
    $[10] = isDisabled;
    $[11] = isInvalid;
    $[12] = showErrorIcon;
    $[13] = size;
    $[14] = sizeVariant;
    $[15] = style;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== LeftIcon || $[19] !== insideCombobox || $[20] !== isLoading || $[21] !== props || $[22] !== ref || $[23] !== showErrorIcon || $[24] !== style) {
    t5 = t6 => {
      const {
        isDisabled: isDisabled_0
      } = t6;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [LeftIcon && /*#__PURE__*/_jsx(LeftIcon, {
          className: icon({
            isDisabled: isDisabled_0
          }),
          "aria-hidden": true
        }), /*#__PURE__*/_jsx(AriaInput, {
          ref: ref,
          className: input({
            disabled: isDisabled_0,
            withIcon: LeftIcon != null,
            style
          }),
          ...props,
          disabled: isDisabled_0
        }), isLoading && /*#__PURE__*/_jsx(Spinner, {
          isLoading: isLoading,
          sizeVariant: "sm"
        }), showErrorIcon && /*#__PURE__*/_jsx(AlertCircle, {
          className: errorIcon({
            insideCombobox
          })
        })]
      });
    };
    $[18] = LeftIcon;
    $[19] = insideCombobox;
    $[20] = isLoading;
    $[21] = props;
    $[22] = ref;
    $[23] = showErrorIcon;
    $[24] = style;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== isDisabled || $[27] !== isInvalid || $[28] !== t4 || $[29] !== t5) {
    t6 = /*#__PURE__*/_jsx(Group, {
      isInvalid: isInvalid,
      isDisabled: isDisabled,
      className: t4,
      children: t5
    });
    $[26] = isDisabled;
    $[27] = isInvalid;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
};
export const Input = /*#__PURE__*/React.forwardRef(BaseInput);
//# sourceMappingURL=Input.js.map